import * as React from "react";
export class MainHeading extends React.PureComponent {
    render() {
        return (React.createElement("h3", { className: `rj-ev-list__main-heading ${`rj-ev-list__main-heading--${this.props.cardType.toLowerCase()}`}`, "data-uat": "h3-ev-list-main-heading" }, this.props.children));
    }
}
//# sourceMappingURL=MainHeading.js.map